import { FilterDefinition, ListViewFilters } from '../types';

/**
 * Returns true when the filter value should be ignored (not applied).
 */
export function isEmptyFilterValue(value: unknown): boolean {
  if (value == null || value === '') {
    return true;
  }

  if (Array.isArray(value) && value.length === 0) {
    return true;
  }

  return false;
}

/**
 * Applies FilterDefinition.filterFn (or default field equality) to a full in-memory list.
 */
export function applyLocalFilters<T>(
  items: T[],
  filterDefinitions: FilterDefinition[],
  filterValues: ListViewFilters,
): T[] {
  if (!filterDefinitions.length) {
    return items;
  }

  return items.filter((item) =>
    filterDefinitions.every((def) => {
      const value = filterValues[def.name];
      if (isEmptyFilterValue(value)) {
        return true;
      }

      const match =
        def.filterFn ??
        ((it: unknown, val: unknown) => (it as Record<string, unknown>)[def.name] === val);

      return match(item, value);
    }),
  );
}
